import { DeleteIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'

import { deleteLanguageTestTemplate } from '../../../api/language-test/delete-language-test-template'
import { LanguageTestTemplate } from '../../../lib/types/models/language-test/language-test-template'
import { queryClient } from '../../../main'

interface LanguageTestTemplateDeleteModalProps {
  template: LanguageTestTemplate
  open: boolean
  onClose: () => void
  onSuccess?: () => void
}

const LanguageTestTemplateDeleteModal = ({
  template,
  open,
  onClose,
  onSuccess
}: LanguageTestTemplateDeleteModalProps) => {
  const { mutateAsync: deleteTemplate, isPending } = useMutation({
    mutationFn: deleteLanguageTestTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['language-test-templates'] })
      onClose()
      onSuccess?.()
    }
  })

  return (
    <Modal
      isOpen={open}
      onCancel={onClose}
      title={`Êtes-vous sûr de vouloir supprimer le test de langue "${template.name}" ?`}
      actionButtonsOptions={{
        confirmText: 'Confirmer',
        cancelText: 'Fermer',
        onConfirm: async () => deleteTemplate(template.id)
      }}
      icon={DeleteIcon}
      variant={'destructive'}
      isLoading={isPending}
    />
  )
}

export default LanguageTestTemplateDeleteModal
